<template>
  <v-app app>
    <v-navigation-drawer
      v-if="userIsAuthenticated"
      app
      v-model="drawer"
      disable-resize-watcher
      expand-on-hover
      permanent
      width="400"
      :mini-variant.sync="mini"
    >
      <v-list dense>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>menu</v-icon>
          </v-list-item-avatar>
        </v-list-item>

        <template v-for="(item, i) in menuItems">
          <v-layout row v-if="item.heading" align-center :key="item.heading">
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>

          <v-list-group
            :key="i"
            :value="false"
            v-else-if="item.children"
            no-action
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.link"
            >
              <v-list-item-action v-if="child.icon">
                <svg-path-icon
                  v-if="child.icon.startsWith('SVG_')"
                  :name="child.icon.substring(4)"
                ></svg-path-icon>
                <v-icon v-else>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <div class="caption">{{ child.title }}</div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :to="item.link" :key="item.title">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> xxx {{ item.title }} </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- Drawer Búsqueda Clientes -->
    <v-navigation-drawer
      width="450"
      right
      app
      clipped
      v-if="userIsAuthenticated"
      v-model="drawerSearch"
      disable-resize-watcher
    >
      <busqueda-clientes-for-drawer></busqueda-clientes-for-drawer>
    </v-navigation-drawer>
    <!-- Drawer Búsqueda Clientes -->

    <!-- Drawer Simulador Cuotas -->
    <v-navigation-drawer
      width="500"
      temporary
      right
      app
      clipped
      v-if="userIsAuthenticated"
      v-model="drawerSimulador"
      disable-resize-watcher
    >
      <simulador-cuotas></simulador-cuotas>
    </v-navigation-drawer>
    <!-- Drawer Simulador Cuotas -->

    <!-- Drawer Help -->
    <!-- <v-navigation-drawer fixed right v-if="userIsAuthenticated" v-model="drawerHelp" disable-resize-watcher temporary>
      <v-toolbar>
        <v-toolbar-title>Ayuda en Línea</v-toolbar-title>
      </v-toolbar>
      <v-card>
          <v-card-title primary-title>
            Items de Ayuda
          </v-card-title>
          <v-card-text>
            <div>Conceptos Generales</div>
            <div>Preguntas Frecuentes</div>
            
          </v-card-text>
      </v-card>
    </v-navigation-drawer> -->
    <!-- Drawer Help -->

    <!-- Drawer Custom Task -->
    <v-navigation-drawer
      clipped
      fixed
      right
      v-if="userIsAuthenticated"
      v-model="showActiveTask"
      disable-resize-watcher
      :width="activeTaskProps ? activeTaskProps.width : 400"
      :temporary="activeTaskProps ? activeTaskProps.temporary : false"
    >
      <v-row v-if="!(activeTaskProps ? activeTaskProps.temporary : false)">
        &nbsp;</v-row
      >
      <v-row v-if="!(activeTaskProps ? activeTaskProps.temporary : false)">
        &nbsp;</v-row
      >
      <v-row v-if="!(activeTaskProps ? activeTaskProps.temporary : false)">
        &nbsp;</v-row
      >
      <component :is="activeTask" v-bind="activeTaskProps"></component>
    </v-navigation-drawer>
    <!-- Drawer Task -->

    <!-- Drawer Custom Sub-Task -->
    <v-navigation-drawer
      clipped
      fixed
      right
      v-if="userIsAuthenticated"
      v-model="showActiveSubTask"
      disable-resize-watcher
      :width="activeSubTaskProps ? activeSubTaskProps.width : 400"
    >
      <v-row>&nbsp;</v-row>
      <component
        :is="activeSubTask"
        v-bind="activeSubTaskProps"
        class="pt-8"
      ></component>
    </v-navigation-drawer>
    <!-- Drawer Sub-Task -->

    <v-app-bar dark app fixed clipped-right :color="colorAmbiente">
      <!-- <v-app-bar-nav-icon v-if="userIsAuthenticated" v-show="!$route.params.parentId" @click.stop="drawer = !drawer" ><v-icon>menu</v-icon></v-app-bar-nav-icon> -->
      <v-toolbar-title>
        <v-row>
          <v-col>
            <v-btn text to="/home">
              <v-img
                to="/home"
                src="../assets/logoargen.png"
                height="50"
                width="200"
              ></v-img>
              <!-- <v-img
                to="/home"
                src="../assets/logofinadi.png"
                height="50"
                max-width="200"
                contain
                style="margin-top: 20px"
              ></v-img> -->
            </v-btn>
          </v-col>
          <!-- <v-col>
            <v-img
              to="/home"
              src="../assets/logoargen.png"
              height="50"
              width="200"
            ></v-img>
          </v-col> -->

          <v-col align-self="center" class="body-2">
            SmarterFinancial - {{ $store.state.version }}
            {{ ambiente.id.includes("Development") ? " - " + ambiente.id : "" }}
          </v-col>
        </v-row>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <app-user-customization
        v-if="userIsAuthenticated"
        :userName="userData.nombre"
      ></app-user-customization>

      <v-btn v-if="userIsAuthenticated" icon @click="onLogout"
        ><v-icon>exit_to_app</v-icon></v-btn
      >

      <!-- Notificaciones -->
      <v-tooltip
        bottom
        v-if="userIsAuthenticated && !userData.esComer && !userData.esComercio"
      >
        <template v-slot:activator="{ on }">
          <!-- <v-btn  v-on="on" icon @click.stop="openNotificacionesGenerales"><v-icon>picture_as_pdf</v-icon></v-btn> -->
          <v-badge
            :value="showNotificacion"
            overlap
            v-on="on"
            color="red"
            dot
            icon
            @click.stop="openNotificacionesGenerales"
          >
            <v-btn
              x-small
              v-on="on"
              depressed
              @click.stop="openNotificacionesGenerales"
              ><v-icon>notifications</v-icon></v-btn
            >
          </v-badge>
        </template>
        <span>Ver Notificación</span>
      </v-tooltip>

      <!-- Politicas Riesgo -->
      <v-tooltip
        bottom
        v-if="userIsAuthenticated && !userData.esComer && !userData.esComercio"
      >
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon @click.stop="openFilePoliticasRiesgo"
            ><v-icon>picture_as_pdf</v-icon></v-btn
          >
        </template>
        <span>Ver Archivo Políticas de Riesgo</span>
      </v-tooltip>

      <!-- Simulador de Cuotas -->
      <v-tooltip bottom v-if="userIsAuthenticated">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            @click.stop="
              (drawerSimulador = !drawerSimulador),
                (drawerSimuladorActivado = true)
            "
            ><v-icon>list_alt</v-icon></v-btn
          >
        </template>
        <span>Simulador de Cuotas</span>
      </v-tooltip>

      <!-- Búsqueda de Clientes -->
      <v-tooltip bottom v-if="userIsAuthenticated">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            v-if="userIsAuthenticated"
            icon
            @click.stop="drawerSearch = !drawerSearch"
            ><v-icon>search</v-icon></v-btn
          >
        </template>
        <span>Búsqueda de Clientes</span>
      </v-tooltip>
      <app-ambiente-customization
        v-if="!userIsAuthenticated"
      ></app-ambiente-customization>
    </v-app-bar>

    <main>
      <v-main>
        <v-container fluid class="pa-2">
          <v-dialog
            v-model="showNotificacionPersistente"
            persistent
            width="500"
            overlay-color="red"
          >
            <v-card>
              <v-card-title class="text-h5"> NUEVA NOTIFICACIÓN </v-card-title>
              <v-card-text
                >ATENCION: Hay nuevas notificaciones que debe leer antes de
                continuar con el uso del Sistema.</v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green darken-1"
                  text
                  @click="openNotificacionesGenerales"
                >
                  Ver Notificación
                </v-btn>
                <v-btn
                  :disabled="showNotificacion"
                  color="green darken-1"
                  text
                  @click="
                    confirmarNotificacionVista();
                    showNotificacionPersistente = false;
                  "
                >
                  Marcar como Leida
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <router-view :key="$route.fullPath"></router-view>
          <alert-box></alert-box>
        </v-container>
      </v-main>
    </main>
    <!-- <v-footer height="auto">
        <v-layout
        justify-center
        row
        wrap
      >
        <v-btn
          v-for="link in links"
          :key="link"
          
          text
          round
        >
          {{ link }}
        </v-btn>
        <v-flex
          primary
          lighten-2
          py-3
          text-xs-center
          white--text
          xs12
        >
          &copy;2019 — <strong>digitalMinds</strong>
        </v-flex>
      </v-layout>
    </v-footer> -->
  </v-app>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

import BusquedaClienteForDrawer from "../components/BusquedaClienteForDrawer";
import SimuladorCuotas from "../components/common/SimuladorCuotas.vue";

import AlertBox from "../components/AlertBox.vue";
import { http } from "@/axios";
import { getMenuesFromUiConfig } from "@/helpers/ui.js";

export default {
  data() {
    return {
      selectedLocale: "EN",
      locales: ["EN", "ID"],
      drawer: false,
      drawerSearch: false,
      drawerHelp: false,
      drawerSimulador: false,
      drawerSimuladorActivado: false,
      drawerTask: false,
      isUserCustomizationVisible: false,
      menuItems: [],
      mini: true,
      showNotificacionPersistente: false,
      links: ["Home", "About Us", "Team", "Services", "Blog", "Contact Us"],
    };
  },
  components: {
    "busqueda-clientes-for-drawer": BusquedaClienteForDrawer,
    "simulador-cuotas": SimuladorCuotas,
    "alert-box": AlertBox,
  },
  created() {
    if (this.$i18n) this.$i18n.locale = this.selectedLocale.toLowerCase();

    this.createMenu();
  },
  watch: {
    $route(to, from) {
      // console.log(to, from)
    },
    "$store.state.UiConfig"() {
      this.createMenu();
    },
    "$store.state.UiCustomUserSettings.temaOscuro"() {
      this.$vuetify.theme.dark =
        this.$store.state.UiCustomUserSettings.temaOscuro;
    },
    "$store.getters.hayNotificacion"() {
      if (
        this.showNotificacion &&
        this.userData.sectorDescripcion != null &&
        this.userData.sectorDescripcion != "Dirección" &&
        this.userData.sectorDescripcion != "Admin"
      )
        this.showNotificacionPersistente = this.showNotificacion;
    },
  },
  computed: {
    userIsAuthenticated() {
      // this.$store.getters.user !== null && this.$store.getters.user !== undefined\
      //Vue.$log.debug(this.$store.getters.user);
      return !!this.$store.getters.isAuthenticated;
    },
    userData() {
      return this.$store.getters.user;
    },
    ambiente() {
      return this.$store.getters.ambiente
        ? this.$store.getters.ambiente
        : { id: "" };
    },
    colorAmbiente() {
      if (this.ambiente.id.includes("Development")) return "green";
      if (this.ambiente.id.includes("Testing")) return "blue";

      return "";
    },
    activeTask() {
      return this.$store.getters.activeTask;
    },
    activeTaskProps() {
      // console.log(this.$store.getters.activeTaskProps)
      return this.$store.getters.activeTaskProps;
    },
    showNotificacion() {
      // console.log(this.$store.getters.activeTaskProps)
      return this.$store.getters.hayNotificacion;
    },
    showfechaNotificacion() {
      // console.log(this.$store.getters.activeTaskProps)
      return this.$store.getters.fechaNotifcacion;
    },
    showfechaNotificacion2() {
      // console.log(this.$store.getters.activeTaskProps)
      return this.$store.getters.fechaNotifcacionUsuario;
    },
    showActiveTask: {
      get() {
        return this.$store.getters.showActiveTask;
      },
      set(val) {
        if (!val) {
          //this.hideActiveTask(this.$store.getters.closeRelatedTasks)
          this.hideActiveTask(this.$store.getters.closeRelatedTasks);
        }
      },
    },
    activeSubTask() {
      return this.$store.getters.activeSubTask;
    },
    activeSubTaskProps() {
      // console.log(this.$store.getters.activeSubTaskProps)
      return this.$store.getters.activeSubTaskProps;
    },
    showActiveSubTask: {
      get() {
        return this.$store.getters.showActiveSubTask;
      },
      set(val) {
        if (!val) {
          this.hideActiveSubTask();
        }
      },
    },
  },
  methods: {
    ...mapGetters([
      "hayNotificacion",
      "fechaNotifcacion",
      "fechaNotifcacionUsuario",
    ]),
    ...mapMutations([
      "setActiveTask",
      "hideActiveTask",
      "setActiveSubTask",
      "hideActiveSubTask",
    ]),
    ...mapActions(["openFilePoliticasRiesgo", "openNotificacionesGenerales"]),
    setLocale(locale) {
      this.selectedLocale = locale;
      if (this.$i18n) this.$i18n.locale = this.selectedLocale.toLowerCase();
    },
    onLogout() {
      this.$store.dispatch("logout", { userLogout: true });
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    },
    createMenu() {
      // creo el menú en base a la configuración de la Ui ($store.UiConfig)
      this.menuItems = getMenuesFromUiConfig(this.$store.getters.UiConfig);

      if (this.$store.debugModeOn) Vue.$log.debug(this.menuItems);
    },
    async confirmarNotificacionVista() {
      // busco el nombre del archivo
      var fileName = await http.get(
        "filemanagement/getfilenotificacionesgenerales/",
      );

      if (fileName) {
        await http.post("filemanagement/notificacionlectura/", {
          info: { usuario: this.userData.login, archivo: fileName.fileName },
        });
      }
    },
  },
};
</script>
